<div class="right-panel h-100 text-grey">
  <div class="main wrap" *ngIf="toShow === true">
    <div *ngFor="let configEntity of configEntities; let i = index" class="col-sm-6 col-md-1 featured_product_cell"
      (click)="redirectTo(configEntity.name, i)">
      <div class="main-icon">
        <span class="{{ configEntity.icon }}" aria-hidden="true"></span>
      </div>
      <div class="main-title">
        <p>{{ configEntity.name }}</p>
      </div>
    </div>
    <div class="col-sm-6 col-md-1 featured_product_cell" *ngIf="hAJsonItems.length > 0">
      <div [ngbPopover]="popContent" [autoClose]="'outside'">
        <div class="main-icon">
          <div class="duo-icons">
            <span class="bi bi-hdd-rack" aria-hidden="true"></span>
            <span *ngIf="hAJsonItems" class="bi tinyIcon" [ngClass]="
              hAJsonItems?.length > 0 &&
              hAJsonItems[1]?.status == 'Active' &&
              hAJsonItems[0]?.status == 'Active'
                ? 'bi-check-circle-fill'
                : 'bi-exclamation-diamond-fill color-red'
            "></span>
          </div>
        </div>
        <div class="main-title">
          <p>High Availability</p>
        </div>
      </div>
    </div>
  </div>
  <ngx-spinner *ngIf="toShow !== true" bdColor="rgba(0,0,0,0)" size="default" color="var(--s-primary-color)"
    type="ball-spin" [fullScreen]="false">
    <p>Please wait ...</p>
  </ngx-spinner>
</div>



<ng-template #popTitle>
  <div class="popover-title">High Availability</div>
</ng-template>

<ng-template #popContent>
  <div class="notify-container text-grey">
    <ng-container *ngFor="let host of hAJsonItems">
      <div class="status-card" [class.is-current]="isCurrentHost(host.mode)">
        <div class="status-content">
          <mat-menu-item>
            <div class="host-header">
              <h5 class="host-name">
                {{ host.mode }}
                <span 
                  class="bi" 
                  [class.bi-arrow-up-circle-fill]="host.isCurrentHostActive"
                  [ngClass]="{'active-icon': host.isCurrentHostActive}"
                  aria-hidden="true">
                </span>
              </h5>
            </div>
            
            <div class="host-details">
              <div class="status-line">
                <span class="label">Status:</span>
                <span class="status-badge" 
                      [ngClass]="getStatusClass(host.status)">
                  {{ host.status }}
                </span>
              </div>
              <!-- <div class="status-line">
                <span class="label">IP:</span>
                <span class="timestamp" >
                  {{ hAJsonItems[1].otherHostIP }}
                </span>
              </div> -->
              <div class="status-line">
                <span class="label">In Sync With:</span>
                <span class="timestamp" >
                  {{ host.otherHostIP }}
                </span>
              </div>
              <div class="timestamp-line">
                <span class="label">State as of:</span>
                <span class="timestamp">{{ host.otherHostLastUpTime }}</span>
              </div>
            </div>

            <ng-container *ngIf="isCurrentHost(host.mode)">
              <hr class="divider" />
              <div class="current-host-badge">Current Host</div>
            </ng-container>
          </mat-menu-item>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>